import React from 'react';
import cn from 'classnames';
import styles from './NotificationDot.module.scss';

export default function NotificationDot({ className }: { className?: string }) {
  return <div className={cn(styles.notificationDot, className)} />;
}
